import React from "react"
import type { CupomEstabelecimentoFornecedorModel } from "../models/cupomEstabelecimentoFornecedorModel"
import { CupomEstabelecimentoFornecedorInicial } from "../models/cupomEstabelecimentoFornecedorModel"
import type { CupomEstabelecimentoFornecedorActionModel } from "./cupomEstabelecimentoFornecedorActions"

interface CupomEstabelecimentoFornecedorContextValue {
    dados: CupomEstabelecimentoFornecedorModel
    dispatch: React.Dispatch<CupomEstabelecimentoFornecedorActionModel>
    salvar: () => Promise<void>
    erroCarregamento: string | null
}

export const CupomEstabelecimentoFornecedorContext =
    React.createContext<CupomEstabelecimentoFornecedorContextValue>({
        dados: CupomEstabelecimentoFornecedorInicial,
        dispatch: () => undefined,
        salvar: async () => undefined,
        erroCarregamento: null,
    })
